// TODO(https://github.com/all-hands-hq/source/issues/979): Load only local timezone data for each user
import Moment from 'moment-timezone';

export enum TimeRangeEnum {
  ThisWeek = 1,
  ThisMonth,
  ThisQuarter,
  PastWeek,
  PastMonth,
  Past3Months,
  PastQuarter,
  NextWeek,
  NextMonth,
  Next3Months,
  NextQuarter,
  Custom,
}

export interface TimeRange {
  rangeType: TimeRangeEnum;
  displayName: string;
  start: Moment.Moment;
  finish: Moment.Moment;
}

export const getPlexRouteTimeRangeEnum = (
  timeRangeEnum: TimeRangeEnum.ThisWeek | TimeRangeEnum.ThisMonth
): 'this_week' | 'this_month' => {
  switch (timeRangeEnum) {
    case TimeRangeEnum.ThisMonth:
      return 'this_month';
    case TimeRangeEnum.ThisWeek:
      return 'this_week';
  }
};

export const getTimeRange = (
  rangeType: TimeRangeEnum,
  // Note that this gets computed only once, on first render.
  // TODO(https://github.com/all-hands-hq/source/issues/177): Initialize dates using user locale
  now: Moment.Moment = Moment().locale('en-us').tz('America/Los_Angeles')
): TimeRange => {
  switch (rangeType) {
    case TimeRangeEnum.ThisWeek: {
      return {
        rangeType,
        displayName: 'This Week',
        start: now.clone().startOf('week'),
        finish: now.clone().endOf('week'),
      };
    }
    case TimeRangeEnum.ThisMonth: {
      return {
        rangeType,
        displayName: 'This Month',
        start: now.clone().startOf('month'),
        finish: now.clone().endOf('month'),
      };
    }
    case TimeRangeEnum.ThisQuarter: {
      return {
        rangeType,
        displayName: 'This Quarter',
        start: now.clone().startOf('quarter'),
        finish: now.clone().endOf('quarter'),
      };
    }
    case TimeRangeEnum.PastWeek: {
      const finish = now.clone().startOf('week').subtract(1, 'millisecond');
      const start = finish.clone().startOf('week');

      return {
        rangeType,
        displayName: 'Past Week',
        start,
        finish,
      };
    }
    case TimeRangeEnum.PastMonth: {
      const finish = now.clone().startOf('month').subtract(1, 'millisecond');
      const start = finish.clone().startOf('month');

      return {
        rangeType,
        displayName: 'Past Month',
        start,
        finish,
      };
    }
    case TimeRangeEnum.Past3Months: {
      const finish = now.clone().endOf('month');
      const start = now.clone().startOf('month').subtract(2, 'months');

      return {
        rangeType,
        displayName: 'Past 3 Months',
        start,
        finish,
      };
    }
    case TimeRangeEnum.PastQuarter: {
      const finish = now.clone().startOf('quarter').subtract(1, 'millisecond');
      const start = finish.clone().startOf('quarter');

      return {
        rangeType,
        displayName: 'Past Quarter',
        start,
        finish,
      };
    }
    case TimeRangeEnum.NextWeek: {
      const start = now.clone().startOf('week').add(1, 'week');
      const finish = start.clone().endOf('week');

      return {
        rangeType,
        displayName: 'Next Week',
        start,
        finish,
      };
    }
    case TimeRangeEnum.NextMonth: {
      const start = now.clone().startOf('month').add(1, 'month');
      const finish = start.clone().endOf('month');

      return {
        rangeType,
        displayName: 'Next Month',
        start,
        finish,
      };
    }
    case TimeRangeEnum.Next3Months: {
      const start = now.clone().startOf('month');
      const finish = start.clone().add(3, 'months').subtract(1, 'millisecond');

      return {
        rangeType,
        displayName: 'Next 3 Months',
        start,
        finish,
      };
    }
    case TimeRangeEnum.NextQuarter: {
      const start = now.startOf('quarter').add(1, 'quarter');
      const finish = start.clone().endOf('quarter');

      return {
        rangeType,
        displayName: 'Next Quarter',
        start,
        finish,
      };
    }
    case TimeRangeEnum.Custom: {
      return {
        rangeType,
        displayName: 'Next Quarter',
        start: now.clone().startOf('week'),
        finish: now.clone().endOf('week'),
      };
    }
  }
};
